<style lang="scss" scoped>
@import '@/view/qwAuth/index.scss';
.center {
  width: 100%;
  min-width: 1000px;
  display: flex;
  text-align: center;
  justify-content: center;
  margin-top: 168px;
}
.dialog-footer {
  margin-top: 30px;
}
.dialogBox {
  display: flex;
  &_2code {
    margin-right: 40px;
  }
  .desc {
    margin-bottom: 20px;
  }
}
</style>
<template>
  <div>
    <!-- <h2>企业微信营销助手</h2> -->
    <div class="center">
      <QwIndexBlock />
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :before-close="
        () => {
          dialogVisible = false
        }
      "
    >
      <div v-if="show">
        <div class="dialogBox">
          <!-- <img
            class="dialogBox_2code"
            :src="require('@/assets/img/qwLogin/info/getApp2code.png')"
            alt=""
          > -->
          <div>
            <!-- <div class="desc">
              请使用<span style="color: green">微信</span>扫描左侧二维码注册企业微信，也可点击「继续」按钮在新网页中注册企业微信。
            </div>
            <div class="desc">
              务必在完成注册后手动回到本页面进行后续操作。
            </div> -->
            <div class="desc">
              点击【继续】后将为你打开新网页进行注册，务必在完成注册后手动回到本页面进行后续操作
            </div>
            <!-- <el-button
              type="text"
              @click="addApp"
            >
              联系客服
            </el-button> -->
            <div
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="register"
              >
                继 续
              </el-button>
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center"
        >
          <!-- <el-button
            type="text"
            @click="addApp"
          >
           联系客服
          </el-button>
          <el-button
            type="primary"
            @click="register"
          >
            继 续
          </el-button> -->
        </div>
      </div>
      <div v-else>
        <span>点击【我已注册完成】后，将扫码登录进入企微管家后台</span>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center"
        >
          <el-button
            type="primary"
            @click="register"
          >
            重新注册
          </el-button>
          <el-button
            type="primary"
            @click="$router.push({ path: '/auth/login' })"
          >
            我已注册完成
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 安装企业微信 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible2"
      :before-close="
        () => {
          dialogVisible2 = false
        }
      "
    >
      <div v-if="show2">
        <div class="dialogBox">
          <!-- <img
            class="dialogBox_2code"
            :src="require('@/assets/img/qwLogin/info/getApp2code.png')"
            alt=""
          > -->
          <div>
            <!-- <div class="desc">
              请使用<span style="color: rgba(0, 122, 255, 1)">企业微信</span>扫描左侧二维码完成安装，也可点击「继续」按钮在新网页中安装应用到企业微信。
            </div> -->
            <div class="desc">
              点击【继续】后将为你打开新网页进行安装，务必在完成安装后手动回到本页面进行后续操作
            </div>
            <div
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="addApp"
              >
                继 续
              </el-button>
            </div>
          </div>
        </div>
        <!-- <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center"
        >
          <el-button
            type="primary"
            @click="addApp"
          >
            继 续
          </el-button>
        </div> -->
      </div>
      <div v-else>
        <span>点击【我已完成安装】后，将扫码登录进入企微管家后台</span>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center"
        >
          <el-button
            type="primary"
            @click="addApp"
          >
            重新安装
          </el-button>
          <el-button
            type="primary"
            @click="$router.push({ path: '/auth/login' })"
          >
            我已完成安装
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QwIndexBlock from './comps/index/block'
import { QWAuth, QWD3Auth } from '@/api/qwAuth'
export default {
  components: {
    QwIndexBlock
  },
  data () {
    return {
      show: true,
      show2: true,
      dialogVisible: false,
      dialogVisible2: false,
      QWAuthUrl: '',
      QWAppUrl: ''
    }
  },

  watch: {
    dialogVisible (nv) {
      !nv ? (this.show = !nv) : null
    }
  },
  created () {
    this.getQWAuth()
    // this.getQWD3Auth()
  },
  mounted () {},
  methods: {
    callFun () {},
    //安装D3应用到企微
    addApp () {
      console.log('addApp-this.QWAppUrl', this.QWAppUrl)
      this.show2 = false
      window.open('https://open.work.weixin.qq.com/wwopen/industryCase/share/sln15068511377197f6')
      // window.open(this.QWAppUrl)
    },
    //打开注册页
    register () {
      this.show = false
      window.open(this.QWAuthUrl)
    },
    //获取注册地址
    getQWAuth () {
      QWAuth().then((res) => {
        console.log('获取注册地址', res)
        this.QWAuthUrl = res.register_url
      })
    },
    //获取授权第三方应用
    getQWD3Auth () {
      QWD3Auth().then((res) => {
        this.QWAppUrl = res.pre_auth_url
        console.log('获取授权第三方应用', res)
      })
    }
  }
}
</script>
